import {
  Button,
  Container,
  TextField,
  Typography,
  InputAdornment,
} from "@mui/material";
import Logo from "../assets/Logo.png";
import { BANK_NAME } from "../constants/bank";
import React from "react";
import { useParams } from "react-router-dom";
import { resetPassword } from "../actions/auth";
import { useDispatch } from "react-redux";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useSelector } from "react-redux";
import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import { useNavigate } from "react-router-dom";
export default function ResetPassword() {
  const [error, setError] = React.useState("");
  const [loading, setIsLoading] = React.useState(false);
  const { token } = useParams();
  const [showPassword, setShowPassword] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(false);
  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const [postData, setPostData] = React.useState({
    password: "",
    passwordConfirm: "",
  });
  const dispatch = useDispatch();
  const navigate = useNavigate();
  function sendData() {
    if (!postData.password && !postData.passwordConfirm) {
      setError("Please fill in required fields");
      return;
    }

    if (postData.password !== postData.passwordConfirm) {
      setError("Password do not match");
      return;
    }
    const passwordPattern =
      /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^\w\s]).{8,}$/;
    if (!passwordPattern.test(postData.password)) {
      setError(
        "Password should include uppercase letters, lowercase letters, numbers, and characters, and also be at least 8 characters long"
      );
      return;
    }
    setError("");
    setErrorMessage(true);
    setIsLoading(true);

    dispatch(resetPassword(token, postData));
    setTimeout(() => {
      setIsLoading(false);
      setPostData({
        password: "",
        passwordConfirm: "",
      });
    }, 3000);
  }
  const message = useSelector((state) => state);
  return (
    <Container
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          marginTop: "200px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          rowGap: "30px",
          width: "50%",
        }}
      >
        {errorMessage && (
          <Stack sx={{ width: "100%" }} spacing={2}>
            {message.auth.resetError && (
              <Alert severity="error">Error:{message.auth.resetError}</Alert>
            )}
            {message.auth.resetSuccess && (
              <Alert severity="success">{message.auth.resetSuccess}</Alert>
            )}
          </Stack>
        )}
        <img src={Logo} alt={`${BANK_NAME} logo`} />
        <Typography variant="h5">Reset Your Account Password</Typography>
        <TextField
          required
          type={showPassword ? "text" : "password"}
          label="New password"
          value={postData.password}
          onChange={(e) =>
            setPostData({ ...postData, password: e.target.value })
          }
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {showPassword ? (
                  <VisibilityOffIcon
                    style={{ cursor: "pointer" }}
                    onClick={handleTogglePasswordVisibility}
                  />
                ) : (
                  <VisibilityIcon
                    style={{ cursor: "pointer" }}
                    onClick={handleTogglePasswordVisibility}
                  />
                )}
              </InputAdornment>
            ),
          }}
        />
        <TextField
          required
          type={showPassword ? "text" : "password"}
          label="Confirm New password"
          value={postData.passwordConfirm}
          onChange={(e) =>
            setPostData({ ...postData, passwordConfirm: e.target.value })
          }
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {showPassword ? (
                  <VisibilityOffIcon
                    style={{ cursor: "pointer" }}
                    onClick={handleTogglePasswordVisibility}
                  />
                ) : (
                  <VisibilityIcon
                    style={{ cursor: "pointer" }}
                    onClick={handleTogglePasswordVisibility}
                  />
                )}
              </InputAdornment>
            ),
          }}
        />
        <span style={{ color: "red" }}>{error}</span>
        <Button
          onClick={sendData}
          style={{ width: "fit-content" }}
          size="large"
          variant="contained"
        >
          {loading ? "Changing..." : "Submit"}
        </Button>
        <Button
          onClick={(e) => {
            e.preventDefault();
            navigate("/admin/login");
          }}
          style={{ textTransform: "capitalize" }}
        >
          Login instead?
        </Button>
      </div>
    </Container>
  );
}
